import React from 'react';
import { Link } from "react-router-dom";
import styles from './button.module.scss';

/**
 * @type - type might be 'button' by default or 'link' for inner link;
 * @view - button view might be 'small', 'light' or 'dark'; dark by default;
 * @text - text for button;
 * @to - use to put navigate url if choose link type;
 * @onClick - onClick handler in button mode
 * @className - custom class
 */

const Button = ({ type = 'button', view = 'dark',  text, to, onClick, className }) => {

  if (type === 'link') {
    return (
      <div
        className={`
          ${styles.wrapper}
          ${
            (view === 'dark' && styles.dark) ||
            (view === 'light' && styles.light) ||
            (view === 'small' && styles.small)
          }
          ${className && className}
        `}
      >
        <Link
          className={styles.inner}
          to={to}
        >
          { text }
        </Link>
        <span className={styles.shadow}></span>
      </div>
    );
  }

  return (
    <div
      className={`
        ${styles.wrapper}
        ${
          (view === 'dark' && styles.dark) ||
          (view === 'light' && styles.light) ||
          (view === 'small' && styles.small)
        }
        ${className && className}
      `}
    >
      <button
        className={styles.inner}
        onClick={onClick}
      >
        { text }
      </button>
      <span className={styles.shadow}></span>
    </div>
  );
};

export default Button;